import { render, staticRenderFns } from "./PopularRestaurents.vue?vue&type=template&id=13bc9336&"
import script from "./PopularRestaurents.vue?vue&type=script&lang=js&"
export * from "./PopularRestaurents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports